import React from 'react';
import PropTypes from 'prop-types';
import colors from 'customizations/js/color-variables';

export const IconPopular = ({ className }) => (
  <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="icon-filled-path"
      d="M21.127 7.65265C20.9 7.35542 20.4499 7.21416 20.0269 7.30746C19.6036 7.40076 19.3111 7.70545 19.3111 8.05285C19.3111 8.99733 18.3394 9.76549 17.1453 9.76549C15.9509 9.76549 14.9795 8.99733 14.9795 8.05285V1.56763C14.9795 1.25469 14.741 0.972574 14.3753 0.852675C14.0096 0.732978 13.5886 0.799275 13.3088 1.02053C13.1993 1.10738 10.5896 3.18274 7.94595 6.31865C6.38716 8.16771 5.14308 10.0019 4.24863 11.7701C3.11566 14.0101 2.54102 16.1548 2.54102 18.1441C2.54102 23.141 7.68195 27.2062 14.0007 27.2062C20.3197 27.2062 25.4606 23.141 25.4606 18.1441C25.4606 14.9457 24.0025 11.4159 21.127 7.65265ZM14.0007 25.6586C8.76115 25.6586 4.49811 22.2876 4.49811 18.1441C4.49811 14.0655 7.24695 9.94282 9.55316 7.20228C10.8031 5.71694 12.0627 4.46516 13.0222 3.57488V8.05285C13.0222 9.85053 14.8717 11.3131 17.145 11.3131C18.5349 11.3131 19.7665 10.7666 20.5136 9.93093C22.4988 12.8869 23.5036 15.644 23.5036 18.1441C23.5036 22.2876 19.2408 25.6586 14.0007 25.6586Z"
      fill={colors.gray30}
      stroke={colors.gray30}
      strokeWidth="0.5"
    />
    <path
      className="icon-filled-path"
      d="M18.5732 14.5518H15.0681C14.6162 14.5518 14.25 14.8581 14.25 15.2358C14.2498 15.6137 14.6162 15.9202 15.0679 15.9202H16.5983L13.1029 18.8431L11.2029 17.2541C10.8836 16.987 10.3654 16.987 10.0461 17.2541L8.18698 18.8087C7.8674 19.0759 7.8674 19.5091 8.18676 19.7763C8.50634 20.0436 9.02427 20.0434 9.34385 19.7763L10.6245 18.7055L12.5243 20.2945C12.6777 20.4227 12.8858 20.4949 13.1029 20.4949C13.3198 20.4949 13.528 20.4227 13.6814 20.2945L17.7551 16.8878V18.1673C17.7551 18.545 18.1214 18.8514 18.5732 18.8514C19.0251 18.8514 19.3914 18.545 19.3914 18.1673V15.236C19.3914 14.8581 19.0251 14.5518 18.5732 14.5518Z"
      fill={colors.gray30}
      stroke={colors.gray30}
      strokeWidth="0.6"
    />
  </svg>
);

IconPopular.propTypes = {
  className: PropTypes.string,
};

IconPopular.defaultProps = {
  className: '',
};
